<div class="cell auto grid-y tabsDecisionContainer">
    <kiwi-tabs class="cell shrink tabsDecision _backgroundWhite" *ngIf="tabs" [tabs]="tabs | async"></kiwi-tabs>
    <router-outlet></router-outlet>
</div>
